import Vue from 'vue';
import Vuex from 'vuex';

import $_auth from '@/modules/Auth/store';
import $_home from '@/modules/Home/store';
import $_content from '@/modules/Content/store';
import $_entity from '@/modules/Entity/store';
import $_assets from '@/modules/Assets/store';
import $_notification from '@/modules/Notification/store';
import $_feeds from '@/modules/Feeds/store';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    $_auth,
    $_home,
    $_content,
    $_entity,
    $_assets,
    $_notification,
    $_feeds,
  },
});
